import { SVGS } from '../../assets';
import { PromotionTypes } from '../../constants';

export const iconMap: Record<PromotionTypes, string> = {
  [PromotionTypes.PRODUCT_DISCOUNT]: SVGS.DiscountRedIcon,
  [PromotionTypes.BUYXGETY]: SVGS.FreePromotionIcon,
};
